import React, { useEffect, useState } from "react";
import { Container } from '@material-ui/core';
import { emailValidation, requiredFieldValidation } from '../../utils/validation'
import { InputField, PrimaryButton } from "../../elements";
import logo from '../../images/techStart.png';

const RemindPassword = props => {

  const { sendEmail, isEmailSent, isLoading, history, error } = props;

  useEffect(() => {
    if (isEmailSent) {
      setTimeout(() => {
        history.push('/')
      }, 3000)
    }
    // eslint-disable-next-line
  }, [props])

  const [fieldState, setFieldState] = useState({
    email: "",
  });

  const [errorState, setErrorState] = useState({
    email: null,
  });

  const onChange = event => {
    setFieldState({ ...fieldState, [event.target.name]: event.target.value });
  };

  const sendEmailHandler = () => {
    sendEmail(fieldState.email);
  }

  const submitHandle = () => {
    let errors = {
      email: requiredFieldValidation(fieldState.email, 'Email') || emailValidation(fieldState.email)
    }
    setErrorState(errors);
    !Object.values(errors).some(el => !!el) && sendEmailHandler();
  }

  return (
    <div className="auth-page">
      <img src={logo} alt="logo" className="auth-logo" />
      <Container className="auth-card" maxWidth="sm">
        <h3>Remind Password</h3>
        <InputField
          containerStyle={{ marginTop: '40px', marginBottom: '20px' }}
          name='email'
          label='Email'
          disabled={isLoading || isEmailSent}
          value={fieldState.email}
          error={errorState.email}
          onChange={onChange}
          onEnterPress={submitHandle}
        />
        <div style={{ height: '24px', marginBottom: '20px' }}>
          {Boolean(error) && <div className="error text-center">{error}</div>}
          {isEmailSent && <div className="success text-center">Email was sent</div>}
        </div>
        <div className='text-center' style={{ marginBottom: '20px' }}>
          <PrimaryButton
            isLoading={isLoading}
            fullWidth={true}
            disabled={isEmailSent}
            onClick={submitHandle}>
            Remind Password
          </PrimaryButton>
        </div>
        <p className="text-center">
          <a href="/login">{'Back To Login'}</a>
        </p>
      </Container >
      <p className="text-center pb-4">
        Don't have an account? <a href="/registration">Create One</a>
      </p>
    </div >
  );
};

export default RemindPassword;
